export default {
  en: {
    id: 'exercise3',
    title: "Fill in the S,C,Q boxes on the right by following the process we just explained to work out the Question, plus the Situation and the Complication that would make the reader ask that Question.  I will guide you along",
    tasks: [
      {
        endText: {
          text: '',
          delay: 0
        },
        number: {
          text: '',
          style: ''
        },
        title: {
          text: '',
          style: '',
        },
        pyramid: {
          text: 'Drilling for methane',
          style: {opacity: 1}
        },
        s: {
          text: '',
          style: ''
        },
        c: {
          text: '',
          style: ''
        },
        q: {
          text: '',
          style: ''
        },
        checkAnswer: {
          s: false,
          c: false,
          q: false,
        },
        arrows: '',
        additionalInfoBox: {
          text: '',
          style: ''
        },
        showPyramidQuestionField: false,
        isFirst: true,
        isLast: false,
        pyramidQuestion: false,
        showPyramid: false,
        pyramidDelay: 0,
        isBlinkingEffect: true,
        showSoWhatText: false
      },
      {
        number: {
          text: '1',
          delay: 0
        },
        title: {
          text: 'Identify the Subject',
          delay: 0
        },
        pyramid: {
          text: 'Drilling for methane will not be commercially feasible',
          delay: 500
        },
        arrows: `
                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="161"
                        dur="0.505s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="296"
                        dur="0.500s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3"
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 158 293 L 158 293 L 158 293"
                        to="M 161 280 L 159 293 L 145 293"
                        dur="0.5s" />
                </path>`,
        additionalInfoBox: {
          text: '',
        },
        s: {
          delay: 0
        },
        c: {
          delay: 0
        },
        q: {
          delay: 0
        },
        checkAnswer: {
          s: false,
          c: false,
          q: false,
        },
        showPyramidQuestionField: false,
        isFirst: false,
        isLast: false,
        pyramidQuestion: false,
        showPyramid: true,
        pyramidDelay: 0,
        isBlinkingEffect: true,
        showSoWhatText: false
      },
      {
        number: {
          text: '2',
          delay: 0
        },
        title: {
          text: 'State reader’s question',
          delay: 0
        },
        pyramid: {
          text: 'Drilling for methane will not be commercially feasible',
          delay: 0
        },
        arrows: `<line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="412"
                        dur="0.5s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="250"
                        dur="0.5s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3"
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 384 236 L 384 236 L 384 236"
                        to="M 383 223 L 384 236 L 376 241"
                        dur="0.5s" />
                </path>`,
        additionalInfoBox: {
          text: '',
        },
        s: {
          delay: 0
        },
        c: {
          delay: 0
        },
        q: {
          showInput: true,
          text: '',
          delay: 500
        },
        checkAnswer: {
          s: false,
          c: false,
          q: false,
        },
        showPyramidQuestionField: false,
        isFirst: false,
        isLast: false,
        pyramidQuestion: false,
        showPyramid: true,
        pyramidDelay: 0,
        isBlinkingEffect: false,
        showSoWhatText: false
      },
      {
        number: {
          text: '3',
          delay: 0
        },
        title: {
          text: 'State the rough answer (if you know it)',
          delay: 0
        },
        pyramid: {
          showInput: true,
          text: 'Drilling for methane',
          delay: 500
        },
        arrows: `
                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="161"
                        dur="0.505s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="296"
                        dur="0.500s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3"
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 158 293 L 158 293 L 158 293"
                        to="M 161 280 L 159 293 L 145 293"
                        dur="0.5s" />
                </path>`,
        additionalInfoBox: {
          text: '',
        },
        s: {
          showInput: false,
          delay: 0
        },
        c: {
          delay: 0
        },
        q: {
          showInput: true,
          text: '',
          delay: 0
        },
        checkAnswer: {
          s: false,
          c: false,
          q: false,
        },
        showPyramidQuestionField: false,
        isFirst: false,
        isLast: false,
        pyramidQuestion: false,
        showPyramid: true,
        pyramidDelay: 0,
        isBlinkingEffect: false,
        showSoWhatText: false
      },
      {
        number: {
          text: '4',
          delay: 0
        },
        title: {
          text: 'Make a statement about the subject that the reader will agree with you is true.  (Note: Always begin any introduction by making a statement about the subject)',
          delay: 0
        },
        pyramid: {
          showInput: true,
          text: 'Drilling for methane',
          delay: 0
        },
        arrows: `
                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="394"
                        dur="0.505s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="65"
                        dur="0.500s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3"
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 384 65 L 384 64 L 384 65"
                        to="M 379 56 L 384 64 L 377 71"
                        dur="0.5s" />
                </path>

                <line x1="0" y1="186" x2="0" y2="186" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted + 1s"
                        to="394"
                        dur="0.505s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="186"
                        begin="DOMNodeInserted + 1s"
                        to="117"
                        dur="0.500s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3"
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 1.5s"
                        fill="freeze"
                        from="M 384 117 L 384 117 L 384 117"
                        to="M 378 110 L 384 117 L 380 128"
                        dur="0.5s" />
                </path>`,
        additionalInfoBox: {
          text: 'Imagine the reader says “Yes, I know that, so what?”',
          delay: 0
        },
        s: {
          showInput: true,
          delay: 0
        },
        c: {
          showInput: false,
          delay: 0
        },
        q: {
          showInput: true,
          text: '',
          delay: 0
        },
        checkAnswer: {
          s: false,
          c: false,
          q: false,
        },
        showPyramidQuestionField: false,
        isFirst: false,
        isLast: false,
        pyramidQuestion: false,
        showPyramid: true,
        pyramidDelay: 0,
        isBlinkingEffect: true,
        showSoWhatText: false
      },
      {
        number: {
          text: '5',
          delay: 0
        },
        title: {
          text: 'Imagine the reader says “Yes, I know that, so what?”',
          delay: 0
        },
        pyramid: {
          showInput: true,
          text: 'Drilling for methane',
          delay: 0
        },
        arrows: `
                <line x1="0" y1="95" x2="0" y2="0" stroke="#050E61" stroke-width="3">
                  <animate
                      attributeName="x2"
                      from="0"
                      begin="DOMNodeInserted + 1s"
                      to="394"
                      dur="0.500s"
                      fill="freeze"
                  />
                  <animate
                      attributeName="y2"
                      from="95"
                      begin="DOMNodeInserted + 1s"
                      to="160"
                      dur="0.500s"
                      fill="freeze"
                  />
                </line>
                <path d="" stroke="#050E61" stroke-width="3">
                  <animate
                      attributeName="d"
                      begin="DOMNodeInserted + 1.5s"
                      fill="freeze"
                      from="M 385 159 L 385 159 L 385 159"
                      to="M 385 159 L 375 150 L 373 168"
                      dur="0.5s" />
                </path>`,
        additionalInfoBox: {
          text: 'That should lead you to the complication',
          delay: 0
        },
        s: {
          showInput: true,
          text: '',
          delay: 0
        },
        c: {
          showInput: true,
          text: '',
          delay: 0
        },
        q: {
          showInput: true,
          text: '',
          delay: 0
        },
        checkAnswer: {
          s: false,
          c: false,
          q: false,
        },
        showPyramidQuestionField: false,
        isFirst: false,
        isLast: false,
        pyramidQuestion: false,
        showPyramid: true,
        pyramidDelay: 0,
        isBlinkingEffect: false,
        showSoWhatText: true
      },
      {
        number: {
          text: '6',
          delay: 0
        },
        title: {
          showInput: true,
          text: 'The Question and the Answer should match, if not rewrite',
          delay: 0,
          rows: 3
        },
        pyramid: {
          showInput: true,
          text: 'Drilling for methane',
          headerAnswer: '',
          delay: 0
        },
        arrows: `<line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="412"
                        dur="0.5s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="250"
                        dur="0.5s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3"
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 384 236 L 384 236 L 384 236"
                        to="M 383 223 L 384 236 L 376 241"
                        dur="0.5s" />
                </path>

                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="161"
                        dur="0.505s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="296"
                        dur="0.500s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3"
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 158 293 L 158 293 L 158 293"
                        to="M 161 280 L 159 293 L 145 293"
                        dur="0.5s" />
                </path>`,
        additionalInfoBox: {
          text: 'Imagine the reader says “Yes, I know that, so what?”',
          delay: 0
        },
        s: {
          showInput: true,
          text: '',
          delay: 0
        },
        c: {
          showInput: true,
          text: '',
          delay: 0
        },
        q: {
          showInput: true,
          text: '',
          delay: 0
        },
        checkAnswer: {
          s: false,
          c: false,
          q: false,
          showPyramidQuestionField: false
        },
        showAditionalBox: false,
        showPyramidQuestionField: false,
        isFirst: false,
        isLast: false,
        pyramidQuestion: false,
        showPyramid: true,
        pyramidDelay: 0,
        isBlinkingEffect: false,
        showSoWhatText: true
      },
      {
        endText: {
          text: '',
          delay: 0
        },
        number: {
          text: '7',
          delay: 0
        },
        title: {
          showInput: false,
          text: 'Check your SCQ against ours',
          delay: 0,
          rows: 2
        },
        pyramid: {
          showInput: true,
          text: 'Drilling for methane',
          headerAnswer: 'is unlikely to be commercially feasible for us',
          delay: 0
        },
        arrows: `<line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
              <animate
                attributeName="x2"
                from="0"
                begin="DOMNodeInserted"
                to="161"
                dur="0.505s"
                fill="freeze"
              />
              <animate
                attributeName="y2"
                from="20"
                begin="DOMNodeInserted"
                to="296"
                dur="0.500s"
                fill="freeze"
              />
            </line>
            <path d="" stroke="#050E61" stroke-width="3" style="fill: #050E61">
              <animate
                attributeName="d"
                begin="DOMNodeInserted + 0.5s"
                fill="freeze"
                from="M 158 293 L 158 293 L 158 293"
                to="M 161 280 L 159 293 L 145 293"
                dur="0.5s" />
            </path>`,
        additionalInfoBox: {
          text: 'What question does the Top box raise',
          delay: 0
        },
        s: {
          text: 'Thinking about drilling for methane',
          delay: 0
        },
        c: {
          text: 'Don’t want to do unless commercially feasible',
          delay: 0
        },
        q: {
          text: 'Is it commercially feasible?',
          delay: 0
        },
        checkAnswer: {
          s: true,
          c: true,
          q: true,
          showPyramidQuestionField: false
        },
        showAditionalBox: true,
        showPyramidQuestionField: true,
        hideInfoBox: false,
        isFirst: false,
        isLast: false,
        pyramidQuestion: true,
        showPyramid: true,
        pyramidDelay: 0,
        rightArrows: `
            <line x1="160" y1="75" x2="160" y2="75" stroke="#050E61" stroke-width="3">
              <animate
                attributeName="y2"
                from="75"
                begin="DOMNodeInserted + 1s"
                to="340"
                dur="0.500s"
                fill="freeze"
              />
            </line>

            <path d="" stroke="#050E61" stroke-width="3">
              <animate
                attributeName="d"
                begin="DOMNodeInserted + 1.5s"
                fill="freeze"
                from="M 160 339 L 160 339 L 160 339"
                to="M 168 330 L 160 339 L 152 330"
                dur="0.5s" />
            </path>`,
        isBlinkingEffect: false,
        showSoWhatText: true
      },
      {
        endText: {
          text: '',
          delay: 0
        },
        number: {
          text: '8',
          delay: 0
        },
        title: {
          showInput: false,
          text: 'Check your answer',
          delay: 0,
          rows: 2
        },
        pyramid: {
          showInput: true,
          text: 'Drilling for methane',
          headerAnswer: 'is unlikely to be commercially feasible for us',
          delay: 0
        },
        arrows: ``,
        additionalInfoBox: {
          text: 'What question does the Top box raise',
          delay: 0
        },
        s: {
          text: 'Thinking about drilling for methane',
          delay: 0
        },
        c: {
          text: 'Don’t want to do unless commercially feasible',
          delay: 0
        },
        q: {
          text: 'Is it commercially feasible?',
          delay: 0
        },
        checkAnswer: {
          s: true,
          c: true,
          q: true,
          showPyramidQuestionField: true
        },
        showAditionalBox: true,
        showPyramidQuestionField: false,
        hideInfoBox: false,
        isFirst: false,
        isLast: false,
        pyramidQuestion: true,
        showPyramid: true,
        pyramidDelay: 0,
        showDocument: false,
        rightArrows: `
            <line x1="160" y1="75" x2="160" y2="340" stroke="#050E61" stroke-width="3" />

            <path d="M 168 330 L 160 339 L 152 330" stroke="#050E61" stroke-width="3" />`,
        isBlinkingEffect: true,
        showSoWhatText: true
      },
      {
        endText: {
          text: '',
          delay: 0
        },
        number: {
          text: '9',
          delay: 0
        },
        title: {
          showInput: false,
          text: 'Please write the introduction out in prose, as if you were preparing to send the document yourself. When finished, click Next to compare it to the “school solution',
          delay: 0,
          rows: 2
        },
        pyramid: {
          showInput: true,
          text: 'Drilling for methane',
          headerAnswer: 'is unlikely to be commercially feasible for us',
          delay: 0
        },
        arrows: ``,
        additionalInfoBox: {
          text: '',
        },
        s: {
          text: 'Thinking about drilling for methane',
          delay: 0
        },
        c: {
          text: 'Don’t want to do unless commercially feasible',
          delay: 0
        },
        q: {
          text: 'Is it commercially feasible?',
          delay: 0
        },
        checkAnswer: {
          s: true,
          c: true,
          q: true,
          showPyramidQuestionField: true
        },
        showAditionalBox: true,
        showPyramidQuestionField: false,
        hideInfoBox: false,
        isFirst: false,
        isLast: false,
        pyramidQuestion: true,
        showPyramid: true,
        pyramidDelay: 0,
        showDocument: true,
        rightArrows: `
            <line x1="160" y1="75" x2="160" y2="340" stroke="#050E61" stroke-width="3" />

            <path d="M 168 330 L 160 339 L 152 330" stroke="#050E61" stroke-width="3"></path>`,
        isBlinkingEffect: false,
        showSoWhatText: true
      },
      {
        endText: {
          text: '',
          delay: 0
        },
        number: {
          text: '10',
          delay: 0
        },
        title: {
          showInput: false,
          text: 'Please write the introduction out in prose, as if you were preparing to send the document yourself. When finished, click Next to compare it to the “school solution',
          delay: 0,
          rows: 2
        },
        pyramid: {
          showInput: true,
          text: 'Drilling for methane',
          headerAnswer: 'is unlikely to be commercially feasible for us',
          delay: 0
        },
        arrows: ``,
        additionalInfoBox: {
          text: '',
          delay: 0
        },
        s: {
          text: 'Thinking about drilling for methane',
          delay: 0
        },
        c: {
          text: 'Don’t want to do unless commercially feasible',
          delay: 0
        },
        q: {
          text: 'Is it commercially feasible?',
          delay: 0
        },
        checkAnswer: {
          s: true,
          c: true,
          q: true,
          showPyramidQuestionField: true
        },
        showAditionalBox: true,
        showPyramidQuestionField: false,
        hideInfoBox: false,
        isFirst: false,
        isLast: true,
        pyramidQuestion: true,
        showPyramid: true,
        pyramidDelay: 0,
        showDocument: true,
        rightArrows: `
            <line x1="160" y1="75" x2="160" y2="340" stroke="#050E61" stroke-width="3" />
            <path d="M 168 330 L 160 339 L 152 330" stroke="#050E61" stroke-width="3"></path>`,
        isBlinkingEffect: true,
        showSoWhatText: true
      }
    ],
    sTitle: "S = ",
    cTitle: "C = ",
    qTitle: "Q = ",
    pyramidQuestionText: 'Why?',
    showPaperStep: 9,
    connectors: `
                <svg width="924px" height="70px">

                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">
                        <animate
                            attributeName="x2"
                            from="465"
                            begin="1s"
                            to="105"
                            dur="1s"
                            fill="freeze"
                        />
                        <animate
                            attributeName="y2"
                            from="0"
                            begin="1s"
                            to="70"
                            dur="1s"
                            fill="freeze"
                        />
                    </line>


                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">
                        <animate
                            attributeName="y2"
                            from="0"
                            begin="1.5"
                            to="70"
                            dur="1s"
                            fill="freeze"
                        />
                    </line>

                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">
                        <animate
                            attributeName="x2"
                            from="465"
                            begin="2s"
                            to="820"
                            dur="1s"
                            fill="freeze"
                        />
                        <animate
                            attributeName="y2"
                            from="0"
                            begin="2s"
                            to="70"
                            dur="1s"
                            fill="freeze"
                        />
                    </line>
                </svg>`,
    pyramidBlocks: `
                <div class="pyramid-box pyramid-body"
                     ng-class="{'show-pyramid-body': vm.showPyramid}">
<!--                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7 && pyramidQuestion.length >= 3 || vm.currentStateNumber > vm.data.waitPyramidQuestionInputStep"-->
                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7"
                     style="opacity: 0; line-height: 15px;">Amounts of methane in the aquifer are small</p>
                </div>
                <div class="pyramid-box pyramid-body"
                     ng-class="{'show-pyramid-body': vm.showPyramid}">
<!--                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7 && pyramidQuestion.length >= 3 || vm.currentStateNumber > vm.data.waitPyramidQuestionInputStep"-->
                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7"
                     style="opacity: 0; line-height: 15px;">Pressure is unlikely to be sufficient to push the methane up unaided</p>
                </div>
                <div class="pyramid-box pyramid-body"
                     ng-class="{'show-pyramid-body': vm.showPyramid}">
<!--                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7 && pyramidQuestion.length >= 3 || vm.currentStateNumber > vm.data.waitPyramidQuestionInputStep"-->
                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7"
                     style="opacity: 0; line-height: 15px;">We are unlikely to get environmental approval</p>
                </div>
      `,
    additionalBoxText: {
      s: 'Have a problem',
      c: 'Have a solution',
      q: 'How implement?'
    },
    hideStepsText: true,
    correctPaperAnswer: `
        <p class="correct-paper-answer__text">The report the engineers at X Company make compelling reading, and I can see that there is great excitement around the office in thinking about drilling the likely windfall from drilling for methane.</p>
        <p class="correct-paper-answer__text">We do not want to go ahead, of course, unless we can be certain that the project will actually be commercially feasible.</p>
    `,
    // waitPyramidQuestionInput: true
  }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b1/findingReadersQuestion/i18n/drillingForMethane.js